import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function BookingConfigDialog({ open, onOpenChange }) {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["seminar-booking-config"], queryFn: async () => (await api.get("/seminar-bookings/config")).data, enabled: open });
  const [f, setF] = useState({ payment_instructions: "", notify_email: "" });
  useEffect(() => { if (data) setF(data); }, [data]);
  const save = useMutation({
    mutationFn: async () => (await api.put("/seminar-bookings/config", f)).data,
    onSuccess: () => { toast.success("Impostazioni salvate"); qc.invalidateQueries({ queryKey: ["seminar-booking-config"] }); onOpenChange(false); },
    onError: (e) => toast.error(e.response?.data?.detail || "Errore"),
  });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Pagamento e notifiche</DialogTitle>
          <DialogDescription>Le istruzioni compaiono sulla pagina pubblica e nell'email di conferma.</DialogDescription>
        </DialogHeader>
        <div><Label className="text-xs">Istruzioni di pagamento</Label>
          <Textarea rows={6} value={f.payment_instructions} onChange={(e) => setF({ ...f, payment_instructions: e.target.value })} className="mt-1"
            placeholder={"Bonifico: IBAN [inserisci IBAN] intestato a [intestatario]\nCausale: Seminario + nome e cognome\nOppure in contanti il giorno del seminario"} data-testid="bookings-config-instructions"/>
        </div>
        <div><Label className="text-xs">Email segreteria per gli avvisi di nuova prenotazione</Label>
          <Input type="email" value={f.notify_email || ""} onChange={(e) => setF({ ...f, notify_email: e.target.value })} className="mt-1" placeholder="segreteria@…" data-testid="bookings-config-email"/>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button className="bg-[#1C352D] hover:bg-[#264A3E]" onClick={() => save.mutate()} disabled={save.isPending} data-testid="bookings-config-save">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
